export default __webpack_public_path__ + "static/media/Ialligatordark.3375766e.png";